export default __webpack_public_path__ + "static/SR France - Nanotechnology - Statement-038d19e6a1b9ea1f88de641f16614a2c.pdf";